import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.relatedTerms,
	components: () => [import(/* webpackChunkName: 'relatedTerms' */ './component')],
	render: ([RelatedTerms]) => <RelatedTerms />,
};

export default routes;
